import { SEAT_IDS } from '../HallSeating/components/GridSeats/constants'

export const LEGEND_SEATS = [
    { type: 'classic', size: 'single', seatIds: [SEAT_IDS.CLASSIC, SEAT_IDS.ATMOS], withTooltip: true },
    { type: 'classic', size: 'double', seatIds: [SEAT_IDS.CLASSIC_DOUBLE, SEAT_IDS.ATMOS_DOUBLE], withTooltip: false },
    { type: 'vip', size: 'single', seatIds: [SEAT_IDS.VIP, SEAT_IDS.ATMOS_VIP], withTooltip: true },
    { type: 'vip', size: 'double', seatIds: [SEAT_IDS.VIP_DOUBLE], withTooltip: false },
    { type: 'gold', size: 'single', seatIds: [SEAT_IDS.GOLD], withTooltip: true },
    { type: 'deluxe', size: 'single', seatIds: [SEAT_IDS.TDL], withTooltip: true },
    {
        type: 'wheelchair',
        size: 'single',
        seatIds: [
            SEAT_IDS.WHEELCHAIR,
            SEAT_IDS.ATMOS_WHEELCHAIR,
            SEAT_IDS.GOLD_WHEELCHAIR,
            SEAT_IDS.TDL_WHEELCHAIR,
            SEAT_IDS.TDL_FAMILY_WHEELCHAIR,
            SEAT_IDS.BOUTIQUE_WHEELCHAIR,
        ],
        withTooltip: true,
    },
    { type: 'positionable', size: 'single', seatIds: [SEAT_IDS.POSITIONABLE], withTooltip: true },
    { type: 'positionable', size: 'double', seatIds: [SEAT_IDS.POSITIONABLE_DOUBLE], withTooltip: true },
    { type: 'boutique', size: 'single', seatIds: [SEAT_IDS.BOUTIQUE], withTooltip: true },
]
